export enum Routes {
  HOME = '/',
  JOIN = '/unete2'
};
